import { OutboundLink } from "react-ga";
import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = () => ({
  container: {
    marginTop: "4rem",
    marginBottom: "1rem"
  },
  button: {
    borderRadius: "5px",
    fontFamily: "Arial",
    fontSize: "1.2rem",
    backgroundColor: "#3498db",
    color: "#fff",
    padding: "1rem 4rem 1rem 4rem",
    textDecoration: "none",
    border: "none",
    width: "auto"
  },
  text: {
    fontSize: "1rem",
    textAlign: "center",
    padding: "1rem"
  }
});

const OrderButton = ({ classes, eventlabel, mailinfo, label, phonenumber }) => (
  <div className={classes.container}>
    <OutboundLink
      className={classes.button}
      eventLabel={eventlabel}
      to={mailinfo}
    >
      {label}
    </OutboundLink>
    <p className={classes.text}>Or call us on {phonenumber}</p>
    <p className={classes.text}>NB: All prices exclude VAT</p>
  </div>
);

OrderButton.propTypes = {
  classes: PropTypes.object,
  eventlabel: PropTypes.string,
  mailinfo: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  phonenumber: PropTypes.string.isRequired
};

export default injectSheet(styles)(OrderButton);



// WEBPACK FOOTER //
// ./src/components/OrderButton.jsx